module.exports = __webpack_public_path__ + "static/johann-d0e3bdf69452523aee8c8967371d6071.png";